import { Image } from "react-native";
import { THIINGS, type ThiingsIconName } from "./icons";

type Props = {
  name: ThiingsIconName;
  size?: number;
};

export default function ThiingsIcon({ name, size = 24 }: Props) {
  return (
    <Image
      source={{ uri: THIINGS[name] }}
      style={{ width: size, height: size }}
    />
  );
}
